import * as types from '../constants/tickets';
import api from '../api';

export const fetchTicketsOpenedStart = () => {
  return {
    type: types.FETCH_TICKETS_OPENED_START
  }
};

export const fetchTicketsOpenedSuccess = (payload) => {
  return {
    type: types.FETCH_TICKETS_OPENED_SUCCESS,
    payload
  }
};

export const fetchTicketsOpenedFailure = (err) => {
  return {
    type: types.FETCH_TICKETS_OPENED_FAILURE,
    err
  }
};

export const fetchTicketsOpened = (payload, cb) => (dispatch) => {
  const {
    timeZone
  } = payload;

  dispatch(fetchTicketsOpenedStart());

  api.get(`api.php?cmd=openedTickets&timeZone=${timeZone}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchTicketsOpenedSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchTicketsOpenedFailure(err));
    })
};

export const fetchTicketsClosedStart = () => {
  return {
    type: types.FETCH_TICKETS_CLOSED_START
  }
};

export const fetchTicketsClosedSuccess = (payload) => {
  return {
    type: types.FETCH_TICKETS_CLOSED_SUCCESS,
    payload
  }
};

export const fetchTicketsClosedFailure = (err) => {
  return {
    type: types.FETCH_TICKETS_CLOSED_FAILURE,
    err
  }
};

export const fetchTicketsClosed = (payload, cb) => (dispatch) => {
  const {
    timeZone
  } = payload;

  dispatch(fetchTicketsClosedStart());

  api.get(`api.php?cmd=closedTickets&timeZone=${timeZone}`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchTicketsClosedSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchTicketsClosedFailure(err));
    })
};

export const fetchTicketDetailsStart = () => {
  return {
    type: types.FETCH_TICKET_DETAILS_START
  }
};

export const fetchTicketDetailsSuccess = (payload) => {
  return {
    type: types.FETCH_TICKET_DETAILS_SUCCESS,
    payload
  }
};

export const fetchTicketDetailsFailure = (err) => {
  return {
    type: types.FETCH_TICKET_DETAILS_FAILURE,
    err
  }
};

export const fetchTicketDetails = (payload, cb) => (dispatch) => {
  const {
    ticketId,
    timeZone
  } = payload;

  dispatch(fetchTicketDetailsStart());

  api.get(`api.php?cmd=ticketDetails&ticketId=${ticketId}&timeZone=${timeZone}`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchTicketDetailsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchTicketDetailsFailure(err));
    })
};

export const addTicketMessageStart = () => {
  return {
    type: types.ADD_TICKET_MESSAGE_START
  }
};

export const addTicketMessageSuccess = (payload) => {
  return {
    type: types.ADD_TICKET_MESSAGE_SUCCESS,
    payload
  }
};

export const addTicketMessageFailure = (err) => {
  return {
    type: types.ADD_TICKET_MESSAGE_FAILURE,
    err
  }
};

export const addTicketMessage = (payload, cb) => (dispatch) => {
  dispatch(addTicketMessageStart());

  api.post(`api.php?cmd=addTicketMessage`, payload)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(addTicketMessageSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(addTicketMessageFailure(err));
    });
};

export const createTicketStart = () => {
  return {
    type: types.CREATE_TICKET_START
  }
};

export const createTicketSuccess = (payload) => {
  return {
    type: types.CREATE_TICKET_SUCCESS,
    payload
  }
};

export const createTicketFailure = (err) => {
  return {
    type: types.CREATE_TICKET_FAILURE,
    err
  }
};

export const createTicket = (payload, cb) => (dispatch) => {
  dispatch(createTicketStart());

  api.post(`api.php?cmd=createTicket`, payload)
    .then(() => {
      dispatch(createTicketSuccess());

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(createTicketFailure(err));
    });
};

export const closeTicketStart = () => {
  return {
    type: types.CLOSE_TICKET_START
  }
};

export const closeTicketSuccess = (payload) => {
  return {
    type: types.CLOSE_TICKET_SUCCESS,
    payload
  }
};

export const closeTicketFailure = (err) => {
  return {
    type: types.CLOSE_TICKET_FAILURE,
    err
  }
};

export const closeTicket = (payload, cb) => (dispatch) => {
  dispatch(closeTicketStart());

  api.post(`api.php?cmd=closeTicket`, payload)
    .then(() => {
      dispatch(closeTicketSuccess());

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(closeTicketFailure(err));
    });
};

export const fetchNewTicketsStart = () => {
  return {
    type: types.FETCH_NEW_TICKETS_START
  }
};

export const fetchNewTicketsSuccess = (payload) => {
  return {
    type: types.FETCH_NEW_TICKETS_SUCCESS,
    payload
  }
};

export const fetchNewTicketsFailure = (err) => {
  return {
    type: types.FETCH_NEW_TICKETS_FAILURE,
    err
  }
};

export const fetchNewTickets = (cb) => (dispatch) => {
  dispatch(fetchNewTicketsStart());

  api.get(`api.php?cmd=newTickets`)
    .then(({ data }) => {
      const payload = data.data[0].count;
      dispatch(fetchNewTicketsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchNewTicketsFailure(err));
    })
};
